import React from "react";
import { View, Text, StyleSheet } from "react-native";
import metrics from "@constants/metrics";
import SuspendedIcon from "@assets/svg/SuspendedIcon";
import { fontFamily } from "@utils/styles";
import Button from "@components/Button";
import SuspensionHOC from "@components/SuspensionHOC";
import color from "@constants/color";
import t from "@constants/localization";

const PATH = "screens/Home/SuspensionMsg";

function SuspensionMsg(props) {
  const {
    is_suspended,
    showSuspensionModal,
    fetchMeCompleted,
    onClickRaiseSupportTicket,
  } = props;

  if (fetchMeCompleted && is_suspended && !showSuspensionModal) {
    return (
      <View style={styles.suspendedCardView}>
        <View style={styles.subContainer}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <SuspendedIcon width={26} height={26} />
            <Text style={styles.suspendedText}>
              {t(`${PATH}/accSuspended`)}
            </Text>
          </View>
          <Button
            borderRadius={6}
            btnText={t(`${PATH}/raiseTicket`)}
            height={32}
            buttonWidth={96}
            textStyle={styles.buttonTextStyleCard}
            onPress={onClickRaiseSupportTicket}
            containerStyle={styles.btnStyle}
          />
        </View>
        <View>
          <Text style={styles.suspensionMsg}>
            {t(`${PATH}/raiseTicketMsg`)}
          </Text>
        </View>
      </View>
    );
  }
  return null;
}

export default SuspensionHOC(SuspensionMsg);

const styles = StyleSheet.create({
  buttonTextStyleCard: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 12,
  },
  subContainer: {
    flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  suspendedCardView: {
    width: metrics.screenWidth - 32,
    marginHorizontal: 16,
    paddingHorizontal: 12,
    paddingTop: 20,
    paddingBottom: 16,
    backgroundColor: "white",
    height: 120,
    borderWidth: 2,
    borderRadius: 10,
    borderColor: color.plain_red,
    shadowColor: "rgba(0, 0, 0, 0.05)",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  suspensionMsg: {
    textAlign: "left",
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 12,
    marginTop: 12,
    color: color.lightBlack,
  },
  suspendedText: {
    fontFamily: fontFamily.bold,
    fontSize: 18,
    marginLeft: 5,
    lineHeight: 30,
  },
  btnStyle: {
    justifyContent: "center",
    alignSelf: "center",
    alignContent: "center",
  },
});
